import type { Maybe, SearchResult } from '../../../../common/types';

const SearchResultLoomVideoPartial = `
... on SearchResultLoomVideo {
	createdAt
	creatorAaid
	creatorName
	durationSeconds
	lastModifiedDate
	thumbnailUrl
	videoType
}
`;

export type SearchLoomVideoType = 'ASYNC_VIDEO' | 'MEETING_RECORDING';

export interface SearchResultLoomVideo extends SearchResult {
	__typename: 'SearchResultLoomVideo';
	createdAt?: Maybe<string>;
	creatorAaid?: Maybe<string>;
	creatorName?: Maybe<string>;
	durationSeconds?: Maybe<number>;
	lastModifiedDate?: Maybe<string>;
	thumbnailUrl?: Maybe<string>;
	type: 'video';
	videoType: SearchLoomVideoType;
}

export const isSearchResultLoomVideo = (partial: SearchResult): partial is SearchResultLoomVideo =>
	partial.__typename === 'SearchResultLoomVideo';

export const getLoomVideoPartials = (): string => SearchResultLoomVideoPartial;
